import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Sidebar } from '../components';
import { Role } from '../models';
import { RestoAdminLink } from '../models/Routes';
import { RestoAdminFoodTemplateEdit, RestoAdminFoodTemplates, RestoAdminUsers } from '../scenes';
import RolesGuard from '../scenes/admin/components/RolesGuard';

const RestoAdminLayout = () => {
  return (
    <RolesGuard requiredRole={Role.RESTO_ADMIN}>
      <div className='sidebar-layout'>
        <Sidebar role={Role.RESTO_ADMIN} />
        <div className='main-container'>
          <Switch>
            <Route path={RestoAdminLink.FOOD_TRAY_TEMPLATES_EDIT} component={RestoAdminFoodTemplateEdit} />
            <Route path={RestoAdminLink.FOOD_TRAY_TEMPLATES_CREATE} component={RestoAdminFoodTemplateEdit} />
            <Route path={RestoAdminLink.FOOD_TRAY_TEMPLATES} component={RestoAdminFoodTemplates} />
            <Route path={RestoAdminLink.USERS} component={RestoAdminUsers} />
            <Redirect to={RestoAdminLink.FOOD_TRAY_TEMPLATES} />
          </Switch>
        </div>
      </div>
    </RolesGuard>
  );
};

export default RestoAdminLayout;
